import { Injectable, EventEmitter } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '@tech-environments/environment';
import { SessionService } from './session.service';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { CommonService } from './common.service';
import { saveAs } from 'file-saver';

import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '@tech-utils/app-config.service';
import {
  DocmanagerService as sdkService,
  DocumentDataInterface,
  DocumentRefDataInterface,
} from '@techrules/portallib';
import { TechDialogsService } from '../../shared/tech-dialogs.service';

@Injectable({
  providedIn: 'root',
})
export class DocmanagerService {
  private idClient: string;
  public refData: any;
  public documentRefdata$ = new EventEmitter<any>();
  private http: HttpClient;

  constructor(
    private httpBackend: HttpBackend,
    private session: SessionService,
    private commonService: CommonService,
    private dialogService: TechDialogsService,
    private translate: TranslateService,
    private sdkSvc: sdkService
  ) {}

  public getDocuments(): Observable<[DocumentDataInterface]> {
    return this.sdkSvc.getDocuments().pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('getManualDocuments', err);
        return throwError(err);
      })
    );
  }

  public getDocumentRefdata(): Observable<DocumentRefDataInterface> {
    return this.sdkSvc.getDocumentRefdata().pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('getManualDocuments', err);
        return throwError(err);
      })
    );
  }

  public getDocumentFile(id: string): Observable<any> {
    return this.sdkSvc.getDocumentFile(id).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('getManualDocumentFile', err);
        return throwError(err);
      })
    );
  }

  public viewDoc(event, Id) {
    let fileName = event.target.dataset.filename;
    let filetype = event.target.dataset.filetype;
    this.getDocumentFile(Id).subscribe((data) => {
      let mediaType;
      switch (filetype) {
        case 'jpg':
          mediaType = 'image/jpeg';
          break;
        case 'png':
          mediaType = 'image/png';
          break;
        case 'gif':
          mediaType = 'image/gif';
          break;
        case 'tif':
          mediaType = 'image/tif';
          break;
        case 'txt':
          mediaType = 'text/plain';
          break;
        case 'pdf':
          mediaType = 'application/pdf';
          break;
        case 'doc':
          mediaType = 'application/msword';
          break;
        case 'docx':
          mediaType =
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        default:
          mediaType = 'image/jpeg';
          break;
      }
      let file = new File([data], fileName, { type: mediaType });
      let blobUrl = URL.createObjectURL(file);
      window.open(blobUrl, '_blank');
      URL.revokeObjectURL(blobUrl);
    });
  }

  public downloadDoc(event, Id) {
    let fileName = event.target.dataset.filename;
    let filetype = event.target.dataset.filetype;
    this.getDocumentFile(Id).subscribe((data) => {
      let mediaType;
      switch (filetype) {
        case 'jpg':
          mediaType = 'image/jpeg';
          break;
        case 'png':
          mediaType = 'image/png';
          break;
        case 'gif':
          mediaType = 'image/gif';
          break;
        case 'tif':
          mediaType = 'image/tif';
          break;
        case 'txt':
          mediaType = 'text/plain';
          break;
        case 'pdf':
          mediaType = 'application/pdf';
          break;
        case 'doc':
          mediaType = 'application/msword';
          break;
        case 'docx':
          mediaType =
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        default:
          mediaType = 'image/jpeg';
          break;
      }

      let file = new File([data], fileName, { type: mediaType });
      saveAs(file); //funcion el pluggin FileSave
    });
  }

  public viewDescrip(event, Description) {
    let title: string;
    this.translate.get('k000570').subscribe((text: string) => {
      title = text; //Token: Translate
    });
    let description: string = Description;
    this.dialogService.openModalDialog('', title, description, '');
    this.dialogService.displayedModal = true;
  }
}
